import React, {Component} from "react";
import PropTypes from 'prop-types';
import VideoItem from "./VideoItem";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as galleryActions from "../../../actions/gallery";
import ReactImageFallback from "react-image-fallback";
import { API_PATH} from "../../../constants";


class Slider extends Component {

    constructor(props) {
        super(props);
        this.state = {
            withInfo : true,
            showInfo : false,
            downLoad : true,
            currentItem: {}

        };
        this.resetActiveItem = this.resetActiveItem.bind(this);

    }

     componentDidMount() {

         console.log(this.props.galleryInfo);
         this.setState({currentItem: this.props.galleryData.galleryItems });
     }


    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    updateItemIndex(e, type) {
        if(type === 'prev') {
            if(this.props.galleryInfo.itemIndex >0) {
                --this.props.galleryInfo.itemIndex;
            } else {
                this.props.galleryInfo.itemIndex = this.props.galleryData.galleryItems.length-1;
            }

        }
        else{
            if(this.props.galleryInfo.itemIndex < this.props.galleryData.galleryItems.length-1) {
                ++this.props.galleryInfo.itemIndex;
            }
            else {
                this.props.galleryInfo.itemIndex = 0;
            }
        }
        let itemIndex = this.props.galleryInfo.itemIndex;
        let currentItem = this.props.galleryData.galleryItems[itemIndex];
        this.setState({currentItem: currentItem });

        console.log(this.props.galleryInfo.itemIndex);

        var elems = document.querySelectorAll(".sl-item");
        [].forEach.call(elems, function(el) {
            el.classList.remove("active");
        });
        document.querySelectorAll('.sl-item')[this.props.galleryInfo.itemIndex].classList.add('active');

        let data = {"index" :  this.props.galleryInfo.itemIndex};
        this.props.setItemId(data);
        if( this.props.galleryInfo.gal_type === 'VIDEO') {
            var videoCtr = document.getElementById("video"+itemIndex);
            var currentVideo = videoCtr.getElementsByTagName('video')[0];
            currentVideo.pause();
        }
    }


    resetActiveItem() {

        var graphicBlocks = document.getElementsByClassName('glery-main');
        let itemIndex = this.props.galleryInfo.itemIndex;

        if( this.props.galleryInfo.gal_type === 'VIDEO') {
            var videoCtr = document.getElementById("video"+itemIndex);
            var currentVideo = videoCtr.getElementsByTagName('video')[0];
            currentVideo.pause();
        }
        graphicBlocks[itemIndex+1].classList.remove("active");

    }


    render() {

        let items = this.props.galItems;
        let itemIndex = this.props.galleryInfo.itemIndex;
        let currentItem = this.props.galleryData.galleryItems[itemIndex];
        let imgDim = (currentItem && currentItem.img_dim !== " X ") ? currentItem.img_dim :'' ;
       //let currentItem = this.state.currentItem;
        console.log(currentItem)
        console.log(imgDim)
        return (
            <div class="vig-modal modal fade" id="imagepreview" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <button type="button" className="close glery-popup-close" data-dismiss="modal" onClick={() => this.resetActiveItem()}></button>
                        <div className="modal-body">

                            <div class="gallery-modal-wrapper mob-galy">
                                <div id="carouselExampleIndicators" className="carousel slide gallery-modal" data-ride="carousel" >
                                    <div className="carousel-inner">
                                        {items && this.props.galleryInfo.gal_type === 'MY_UPLOADS' &&
                                            items.map((entry, index) => {
                                                let imgpath = entry.img_path;
                                                let defImgSrc = require("./../../../assets/images/no-image.jpg");

                                                return(
                                                    <div className="carousel-item item">
                                                        <ReactImageFallback
                                                            className="d-block w-100 "
                                                            src={imgpath}
                                                            fallbackImage={defImgSrc}
                                                            initialImage={defImgSrc}
                                                            alt="cool image should be here"
                                                        />
                                                    </div>
                                                )
                                            })

                                        }


                                        {items && this.props.galleryInfo.gal_type === 'VIDEO' &&
                                        items.map((entry, index) =>
                                            <VideoItem item = {entry} iteration={index} />
                                        )
                                        }
                                    </div>
                                    <a className="carousel-control-prev" href="#carouselExampleIndicators"
                                       role="button" data-slide="prev"  onClick={(e) => this.updateItemIndex(e,'prev')}>
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="sr-only">Previous</span>
                                    </a>
                                    <a className="carousel-control-next" href="#carouselExampleIndicators"
                                       role="button" data-slide="next" onClick={(e) => this.updateItemIndex(e,'next')}>
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="sr-only">Next</span>
                                    </a>
                                </div>
                                {/*this.state.withInfo &&
                                <div className="gallery-option">
                                    <button className="file-info-gallery" onClick = {(e) => this.showItemInfo(e)}></button>
                                </div>

                               */ }
                                {this.state.withInfo &&
                                <div className="gallery-toggler-block">
                                    <span className="popup-library icon-lib ico-play">Library</span>
                                    <ul className="popup-right-contnt">
                                        {this.props.galleryInfo.gal_type !== 'VIDEO' &&
                                        <li>{imgDim}</li>
                                       }
                                        <li>{parseFloat(currentItem ?currentItem.img_size: 0).toFixed(2)} MB</li>
                                        <li>Type: {currentItem? currentItem.img_type: ''}</li>
                                        <li>Uploaded by: {currentItem? currentItem.uploaded_by: ''}</li>
                                        <li>Date: {currentItem ? currentItem.uploaded_on: ''}</li>
                                        {currentItem && currentItem.download_count >0 && <li>Downloads: {currentItem.download_count}</li>}
                                    </ul>
                                    <div className="galery-popup">

                                        {/*<button className="btn-galery-popup option-uplod" ></button>*/}
                                        {this.state.downLoad && this.props.galleryInfo.gal_type === 'MY_UPLOADS' && this.props.galleryData.galleryItems[this.props.galleryInfo.itemIndex] &&
                                        <a href={API_PATH + "downloadImage.php?filename=" + this.props.galleryData.galleryItems[this.props.galleryInfo.itemIndex].img_path+"&fileid=" + this.props.galleryData.galleryItems[this.props.galleryInfo.itemIndex].id}
                                           download>
                                        <button className="btn-galery-popup option-down"></button>
                                        </a>}
                                        {this.state.downLoad && this.props.galleryInfo.gal_type === 'VIDEO' && this.props.galleryData.galleryItems[this.props.galleryInfo.itemIndex] &&
                                        <a href={API_PATH + "downloadImage.php?filename=" + this.props.galleryData.galleryItems[this.props.galleryInfo.itemIndex].img_path+"&fileid=" + this.props.galleryData.galleryItems[this.props.galleryInfo.itemIndex].id}
                                           download> <button className="btn-galery-popup option-down"></button></a>
                                        }
                                        {/*<button className="btn-galery-popup option-delet"></button>*/}
                                    </div>
                                    <div className="popup-img-num">
                                        <p className="img-num-main"><span className="img-num single-img">{itemIndex+1}</span><span
                                            className="img-num img-total-num"> / {this.props.galleryData.galleryItems.length}</span></p>
                                    </div>
                                </div>
                                }
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }

}

Slider.propTypes = {
    gal_type: PropTypes.string
}

function mapStateToProps(state) {

    return {
        galleryInfo  :state.gallery.galleryUpdate,
        galleryData  :state.gallery.galleryData
    };

}


export default  withRouter(connect(mapStateToProps, {
    setItemId : galleryActions.setItemId,
    download : galleryActions.downloadFile
})(Slider));



// WEBPACK FOOTER //
// ./src/components/includes/Slider/index.js